import script from "./LinkCardEditModal.vue?vue&type=script&setup=true&lang=js"
export * from "./LinkCardEditModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__